import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";

const SubProductAPI = {
    getTypes(){
        const { promise, cancel, requestInfo } =  makeCancellableAPIRequest(
            "GET",
            "/user/sub-product-type"
        );
        return { promise, cancel, requestInfo };
    },
    createType(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/sub-product-type`,
            {
                data
            }
        )
    },
    updateType(data){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/sub-product-type`,
            {
                data
            }
        )
    },
    deleteType(id){
        return  makeCancellableAPIRequest(
            "DELETE",
            `/user/sub-product-type/${id}`,
            {},
            false
        )
    },
    orderType(data){
        return makeCancellableAPIRequest(
            "POST",
            `/user/sub-product-type/order`,
            {
                data
            }
        )
    },
    save(data){
        return failSafe(
            APIClient.post("/api/sub-product", {
                ...data,
            })
        )
    },
    getAll(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/sub-product"
        );
    },
    getClonable(queryParams={}){
        return makeCancellableAPIRequest(
            "GET",
            "/api/sub-product/clone",
            {
                params: queryParams
            }
        );
    },
    getAllWithRespectToProduct(productId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/${productId}/product`,
        )
    },
    get(id, params){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/${id}`, 
            { params }
        );
    },
    update(data){
        return failSafe(
            APIClient.put(`/api/sub-product`, {
                ...data,
            })
        );
    },
    delete(id) {
        return failSafe(
            APIClient.delete(`/api/sub-product/${id}`)
        )
    },
    archiveDelete(id, comment){
        return failSafe(
            APIClient.post(`/api/sub-product/archive/${id}?comment=${comment}&delete=true`)
        )
    },
    getSubProductByBu(businessUnitId, id) {
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/${businessUnitId}/${id}`,
        )
    },
    v2: {
        getAll(params = {}){
            return makeCancellableAPIRequest(
                "POST",
                `/api/dashboard/sub-product/score`,
                {
                    data: params
                }
            )
        }
    },
    getAllQuick(productId, BUaggregation = false){
        let productData;
        if (Array.isArray(productId) || !productId) {
            productData = productId;
        } else {
            productData = [productId];
        }
        const path = BUaggregation ? `/api/businessunits/dashboard/sub-product/elastic/short` : `/api/dashboard/sub-product/name-id`
        return BUaggregation ? makeCancellableAPIRequest(
            "GET",
            path,
            {
                params: {
                    productId
                }
            }
        ) : makeCancellableAPIRequest(
            "POST",
            path,
            {
                data: {
                    productId: productData
                }
            }
        )
    },
    getAllQuick_V2(payload){
        return makeCancellableAPIRequest(
            "POST",
            '/api/sub-product/name-id',
            {
                data: payload
            }
        )
    },
    getByBU(buId, apId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/tenant/businessUnits/${buId}/products/${apId}/subProducts`
        )
    },
    validate(params = {}, showDefaultMessage = false){
        return makeCancellableAPIRequest(
            "GET",
            "/api/sub-product/validate", 
            {
                params
            },
            showDefaultMessage
        )
    },
    getCloneList(id){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/cloned-items/${id}`
        )
    },
    getAppSecStatus(params){
        return makeCancellableAPIRequest(
            "POST",
            `/api/tools/appsec-tools/status-by-subProduct`,
            {
                data: params
            }
        )
    },
    getAppSecStatusV2(restParams){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/appsec-tools/status-aggregated-by`,
            {
                data: {
                    aggregateField: "SUBPRODUCT",
                    ...restParams
                }
            }
        )
    },
    getTicketUrl() {
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/ticket-config-urls`,
        )
    },
    getSSDLCTools(id){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/${id}/ssdlc-tools`
        )
    },
    getDependantProducts(id){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/${id}/dependentproducts`
        )
    },
    moveToAnotherProduct(subproductId, productId, grantAccessOnNewParent){
        const url = `/api/sub-product/${subproductId}/changeProduct/${productId}${grantAccessOnNewParent !== undefined ? `?grantAccessOnNewParent=${grantAccessOnNewParent}` : ''}`;
        return makeCancellableAPIRequest(
            "POST",
            url
        )
    },
    importCSV(data, isEdit){
        return makeCancellableAPIRequest(
            isEdit ? "PUT" : "POST",
            '/api/sub-product/upload',
            {
                data,
                headers: {
                    'content-type': 'multipart/form-data'
                }
            },
       
        )
    },
    getHierarchyInfo(params = {}){
        const finalParams = {
            excludeTags: true,
            ...params
        };
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/team-hierarchy`,
            {
                params: finalParams
            }
        );
    },
    // Give the hierarchy info
    getHierarchyInfoV2(params = {}){
        const finalParams = {
            excludeTags: true,
            ...params
        };
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/team-hierarchy-filtered`,
            {
                params: finalParams
            }
        );
    },
    getFilters(data) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/filter-options`,
            {
                data
            }
        );
    },
    downloadCsvV2(queryParams = {}){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-products/export`,
            {
                data: queryParams,
            }
        )
    },
    bulkUpdate(ids, payload){
        return makeCancellableAPIRequest(
            "PATCH",
            `/api/sub-product/bulk`,
            {
                data: {
                    ids,
                    ...payload
                },
            }
        )
    },
    bulkArchive(ids, note, shouldDelete = false) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/bulk/archive`,
            {
                data: {
                    "subProductIds": ids,
                    "comment": note,
                    delete: shouldDelete
                }
            }
        )
    },
    bulkMove(ids, prodId) {
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/bulk/move`,
            {
                data: {
                    "subProductIds": ids,
                    "productId": prodId
                }
            }
        )
    },
    bulkDelete(ids) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/sub-product/bulk`,
            {
                data: {
                    "subProductIds": ids
                }
            }
        )
    },
    archiveSubProduct(subProductId, note){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/archive/${subProductId}?comment=${note}`
        )
    },
    createVersion({ subProductId, version, cloneManualFindings, status }){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/version`,
            {
                data: {
                    subProductId,
                    version,
                    cloneManualFindings,
                    status
                }
            }
        )
    },
    getVersions(subProductId){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/version/${subProductId}`,
        )
    },
    migrateTriage(data){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/migrate-triage`,
            {
                data
            }
        )
    },
    createBulkVersion({ subProductIds, version, cloneManualFindings, status }){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/bulk/versions`,
            {
                data: {
                    subProductIds,
                    version,
                    cloneManualFindings,
                    status
                }
            }
        )
    },
    getSubProductBulkPreviewVersions({ subProductIds, version, cloneManualFindings }){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/bulk/preview/versions`,
            {
                data: {
                    subProductIds,
                    version,
                    cloneManualFindings
                }
            }
        )
    },
    getSubProductByHierarchy({ subProductIds, productId, groups }){
        return makeCancellableAPIRequest(
            "GET",
            `/api/sub-product/groups`,
            {
                params: {
                    subProductIds,
                    productId,
                    groups,
                }
            }
        )
    },
    fetchAvailableTags(){
        return makeCancellableAPIRequest(
            "POST",
            `/api/sub-product/tag-library`,
        )
    },
    updateOtherProperties(subProductId, data) {
        return makeCancellableAPIRequest(
            "PATCH",
            `/api/sub-product/${subProductId}/properties`,
            { data }
        );
    },
}

export default SubProductAPI;